<div
  (drop)="onFileDrop($event)"
  (dragover)="onDragOver($event)"
  class="rounded-input text-standard-text mb-4 box-border flex w-full cursor-pointer flex-col items-center justify-center border-2 border-dashed text-base border-gray-200">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [id]="id()"
      type="file"
      hidden
      #uploader
      [multiple]="isMultiple()"
      (change)="selectFilesEvent($event)" />

    <div class="flex flex-col gap-2 p-5 text-center">
      <span class="material-symbols-rounded">attach_file</span>
      <span class="py-5">
        {{ description() }}
      </span>
      <aw-button
        [id]="'upload'"
        (click)="uploader.click()"
        [type]="'button'"
        [isFullWidth]="false"
        [text]="formattedLabel()">
      </aw-button>

      @if (ngControl.control!.value && ngControl.control!.value.length > 0) {
        <p>
          <span>{{ ngControl.control!.value.length }} {{ filesChosen() }}</span>
        </p>
        <span
          class="material-symbols-rounded text-input-label z-10 ml-4 cursor-pointer text-xl"
          [attr.data-testid]="id() | appendTestId: 'clear'"
          (click)="ngControl.control!.setValue(undefined)">
          delete
        </span>
      }
    </div>

    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
